import type { StatusTypeEntry } from 'types/shared';

export const WIMAS_CONF_LINK = 'https://welltech.atlassian.net/wiki/x/D4AuMQE';
export const USER_GUIDE_CONF_LINK = 'https://welltech.atlassian.net/wiki/x/lwA8BAE';

export const STATUS_VALUES = ['active', 'paused', 'archived'];
export const STATE_VALUES = ['completed', 'running', 'failed'];

export const WEEK_DAY_VALUES = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
export const WEEK_DAYS = {
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
  7: 'Sunday',
};

export const SIMPLE_LOGS = [
  'archive_rule',
  'pause_rule',
  'unpause_rule',
  'unarchive_rule_as_active',
  'unarchive_rule_as_paused',
  'run_rule_manually',
  'create_flow',
  'delete_flow',
  'create_metric',
  'create_metric_group',
  'delete_metric_group',
  'duplicate_rule',
];

export const STATUS_TABS: StatusTypeEntry[] = [
  {
    id: 1,
    name: 'Active',
  },
  {
    id: 2,
    name: 'Paused',
  },
  {
    id: 3,
    name: 'Archived',
  },
  {
    id: 4,
    name: 'All',
  },
];
